import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import {
  adjustToTimeZoneSafely,
  getObjectId,
  type RrcLocationProfile,
} from '@ots-frontend/ots-data';
import { RrcLocationProfileInspector } from '@ots-frontend/ots-ui-tw';
import type { RrcLocationProfileFormDefaultValues } from '../rrc-profile-route-defaults';

type Props = {
  id?: string;
  copy?: boolean;
  formDefaults?: RrcLocationProfileFormDefaultValues;
};

/** Preserve legacy navigation defaults while the shared form works with plain API values. */
export const locationProfileRouteDefaults = (
  value?: RrcLocationProfileFormDefaultValues
): Partial<RrcLocationProfile> | undefined =>
  value
    ? {
        locationId: value.location?.id,
        locationType: value.location?.type,
        rrcDistrict: value.rrcDistrict?.code,
        effectiveStartDttm: adjustToTimeZoneSafely(
          value.effectiveStartDate
        )?.getTime(),
        effectiveEndDttm: adjustToTimeZoneSafely(
          value.effectiveEndDate
        )?.getTime(),
        facilityName: value.facilityName,
        commercial: value.commercial,
        facilityPermitNumber: value.facilityPermitNumber,
        leaseName: value.leaseName,
        leaseNumber: value.leaseNumber,
        gasPlantNumber: value.gasPlantNumber,
        latCoord: value.latCoord,
        longCoord: value.longCoord,
        contactName: value.contactName,
        contactPhone: value.contactPhone,
        contactEmail: value.contactEmail,
        address: value.address,
        autoEp9SignerId: getObjectId(value.autoEp9Signer),
        autoEp9SignerStrategy: value.autoEp9SignerStrategy?.code,
        autoEp10SignerId: getObjectId(value.autoEp10Signer),
        autoEp10SignerStrategy: value.autoEp10SignerStrategy?.code,
      }
    : undefined;

export const RrcLocationProfileFormPageRoute = () => {
  const { state } = useLocation();
  const [params] = useSearchParams();
  return (
    <RrcLocationProfileFormPage
      id={state?.id ?? params.get('id') ?? undefined}
      copy={state?.copy}
      formDefaults={state?.formDefaults}
    />
  );
};
export const RrcLocationProfileFormPage = ({
  id,
  copy,
  formDefaults,
}: Props) => {
  const navigate = useNavigate();
  return (
    <RrcLocationProfileInspector
      id={id}
      initialMode={copy ? 'copy' : id ? 'edit' : 'create'}
      defaults={locationProfileRouteDefaults(formDefaults)}
      locationLocked={!!formDefaults?.location}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
